import {IComponentOptions, IController, IPromise, IQService} from 'angular';
import {UserContext, UserContextService} from "../user/user-context-service";
import {ProductShootingCommentResource} from "../api/legacy/api/ProductShootingCommentResource";
import * as template from "./product-shooting-comment.component.html";
import {mainModule} from "../app";
import {UserRole} from "vtom-api-typescript-client";
import {ProductSaveListener} from "./product.component";

class Controller implements IController {
    // Input
    product;

    // Output
    registerSaveListener: ({listener: ProductSaveListener}) => void;

    userContext: UserContext;
    productShootingComment;

    private initialComment;

    constructor(
        private readonly UserContextService: UserContextService,
        private readonly ProductShootingCommentResource: ProductShootingCommentResource,
        private readonly $q: IQService,
    ) {}


    save(): IPromise<void> {
        if (!this.isDisplayed()) {
            return this.$q.resolve();
        }
        if (this.initialComment == this.productShootingComment.comments) {
            return this.$q.resolve();
        }
        return this.ProductShootingCommentResource.save(this.productShootingComment)
            .$promise
            .then(productShootingComment => this.productShootingComment = productShootingComment);
    };

    isDisplayed(): boolean {
        return this.product?.id
            && (this.userContext?.hasRole(UserRole.ADMIN) || this.userContext?.hasRole(UserRole.SHOOTER));
    }

    $onInit() {
        if (this.registerSaveListener) {
            this.registerSaveListener({listener: () => this.save()});
        }
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        if (!this.product?.id) {
            return;
        }
        if (onChangesObj.product.previousValue
            && onChangesObj.product.previousValue.id == this.product.id) {
            return;
        }
        this.UserContextService.getContext().then(userContext => {
            this.userContext = userContext;

            if (!this.isDisplayed()) {
                return;
            }
            this.ProductShootingCommentResource.findByProduct({product: this.product})
                .$promise.then(productShootingComment => {
                this.productShootingComment = productShootingComment || {
                    product: this.product,
                    comments: ''
                };
                this.initialComment = this.productShootingComment.comments;
            });
        });
    }

}

const component: IComponentOptions = {
    controller: Controller,
    template: template.default,
    bindings: {
        product: '<',
        registerSaveListener: '&',
    }
};

mainModule.component('productShootingComment', component);
